import { useSyncExternalStore, useCallback } from 'react';
import { viewportStore, ViewportState } from '../store/viewportStore';

/**
 * Custom hook for accessing and updating viewport state (pan, zoom, view mode).
 * Uses a sync external store for performance and cross-component updates.
 * @returns Tuple of [viewport state, setViewport update function]
 * @example
 * const [viewport, setViewport] = useViewport();
 * setViewport({ scale: viewport.scale * 1.1 }); // zoom in
 */
export function useViewport() {
  const state = useSyncExternalStore(
    (callback) => viewportStore.subscribe(callback),
    () => viewportStore.getState()
  );

  const setViewport = useCallback(
    (updates: Partial<ViewportState> | ((state: ViewportState) => Partial<ViewportState>)) => {
      viewportStore.setState(updates);
    },
    []
  );

  return [state, setViewport] as const;
}
